// extracted by mini-css-extract-plugin
export default {"modalButtonArea":"ViewPopup_modalButtonArea__U1pFf","moduleHeaderArea":"ViewPopup_moduleHeaderArea__gDH1x","disbaleBtn":"ViewPopup_disbaleBtn__JOG9s"};